import { atom } from 'recoil';


export interface IReminderType {
  ReminderTypeId: string;
  CategoryId: string;
  CategoryName: string;
  SubCategoryId: string;
  SubCategoryName: string;
  IsRecurring: boolean;
  Name: string;
  Code: string;
  Description: string;
  TimeTriggerRequired: boolean;
  TimeTriggerRepeatIntervalTypeName: string;
  TimeTriggerRepeatIntervalValue: number,
  TimeTriggerDueSoonThresholdIntervalTypeName: string;
  TimeTriggerDueSoonThresholdIntervalValue: number;
  OdometerTriggerRequired: boolean;
  OdometerTriggerRepeatIntervalKm: number;
  OdometerTriggerDueSoonThresholdIntervalKm: number;
  OperationalHoursTriggerRequired: boolean
  OperationalHoursTriggerRepeatIntervalHours: number;
  OperationalHoursTriggerDueSoonThresholdIntervalHours: number;
  SetNextDueBasedOnId: string;
  SetNextDueBasedOnName: string;
  OdometerTriggerTimeBasedDueSoonThresholdIntervalValue: string;
  OdometerTriggerTimeBasedDueSoonThresholdIntervalTypeName: string;
}


export const reminderTypeTabListState = atom<IReminderType[]>({
  key: "reminderTypeTabListState",
  default: [],
});

export const reminderTypeTabIndexState = atom<number>({
  key: "reminderTypeTabIndexState",
  default: 0,
});


export const reminderTypeListRefreshState = atom({
  key: "reminderTypeListRefreshState",
  default: true,
});